export default __webpack_public_path__ + "static/media/1.f390e909.jpeg";